.kt{color:var(--status-error);}